export default "__VITE_ASSET__a29c9e80__"